<template>
  <v-data-table
    :headers="headers"
    :items="notifications"
    :items-per-page="10"
    class="elevation-1"
    locale="zh-cn"
    v-model="selected"
    show-select
    item-key="Reference"
  >
    <template v-slot:top>
      <div class="d-flex justify-end mt-2 mr-5">
        <v-btn
          small
          outlined
          color="primary"
          :disabled="selected.length == 0"
          @click="batchApprove"
          >批量同意</v-btn
        >
      </div>
    </template>
    <template v-slot:item.Actions="{ item }">
      <v-btn small @click="approve(item)" color="primary">同意</v-btn>
      <v-btn small @click="reject(item)" color="error">拒绝</v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { baseService } from "@/api/base-service";
import moment from "moment";
export default {
  name: "AdminPage",
  props: {
    isShow: Boolean,
  },
  data() {
    return {
      headers: [
        { text: "预约人姓名", value: "BookerName" },
        { text: "预约人学工号", value: "BookerId" },
        { text: "预约类型", value: "Name" },
        { text: "预约资源", value: "Resource" },
        { text: "时间", value: "DateTime" },
        { text: "时长(分钟)", value: "Duration" },
        { text: "操作", value: "Actions" },
      ],
      notifications: [],
      selected: [],
      isLoading: false,
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.selected = [];
      this.isLoading = true;
      let _notifs = await baseService.getNotifications();
      if (_notifs == null || _notifs.length == 0) this.$router.push('/')
      this.notifications = _notifs.Results.map((o) => ({
        Reference: o.Reference,
        BookerName: o.BookerName,
        BookerId: o.BookerId,
        Name: o.EventName,
        Resource: o.ResourceName,
        DateTime: moment(o.Schedule[0].StartDateTime).format(
          "YYYY-MM-DD HH:mm"
        ),
        Duration: o.Schedule[0].Duration,
        ApproveLink: o.ApproveLink,
        RejectLink: o.RejectLink,
      }));
      this.isLoading = false;
    },
    async approve(item) {
      console.log(item);
      try {
        this.isLoading = true;
        await baseService.operateStatus(item.ApproveLink);
      } catch (e) {
        alert("审批失败");
      }
      await this.initialize();
      this.isLoading = false;
    },
    async reject(item) {
      console.log(item);
      try {
        this.isLoading = true;
        await baseService.operateStatus(item.RejectLink);
      } catch (e) {
        alert("拒绝失败");
      }
      await this.initialize();
      this.isLoading = false;
    },
    async batchApprove() {
      this.isLoading = true;
      let i = 0;
      let that = this;
      for (let i = 0; i < this.selected.length; i++) {
        let n = that.selected[i];
        try {
          await baseService.operateStatus(n.ApproveLink);
        } catch (e) {
          alert(n.Name + " 审批失败");
        }
      }
      await this.initialize();
      this.isLoading = false;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/management/AdminPage.vue